<template>
  <div>
    <FloatingButton v-if="!isDisabled" is-static-position @click="handleClick">
      <MaterialIcon
        :icon-type="iconType.OUTLINED"
        icon-name="check_circle"
        class="u-mr-10 u-fz-24"
      ></MaterialIcon>
      応募フォームへ
    </FloatingButton>
    <FloatingButton
      v-else
      is-static-position
      :disabled="isDisabled"
      type="disabled"
    >
      <MaterialIcon
        :icon-type="iconType.OUTLINED"
        icon-name="check_circle"
        class="u-mr-10 u-fz-24"
      ></MaterialIcon>
      応募済み
    </FloatingButton>
  </div>
</template>

<script>
import Vue from "vue"
import FloatingButton from "~/components/guideline/button/FloatingButton.vue"
import MaterialIcon, {
  OUTLINED,
} from "~/components/guideline/icon/MaterialIcon.vue"

export default Vue.extend({
  components: {
    FloatingButton,
    MaterialIcon,
  },
  props: {
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      iconType: { OUTLINED },
    }
  },
  methods: {
    handleClick() {
      this.$emit("click")
    },
  },
})
</script>
